export default __webpack_public_path__ + "static/media/right_arr.e69630ed.svg";